export const formContentStyle = {
	wrapper: {
		marginBottom: '40px',
	},

	header: {
		marginBottom: '24px',
		textAlign: 'center',
		height: '32px',

		'@media (max-width: 1199.98px)': {
			display: 'none',
			marginBottom: '0',
		},
	},

	content: {
		display: 'flex',
		gap: '12px',
		width: '100%',
		flexDirection: 'column',
		marginBottom: '24px',
	},

	ticket: {
		display: 'flex',
		gap: '12px',
	},

	ticketNumber: {
		maxWidth: '64px',
		width: '100%',
	},

	ticketName: {
		width: '372px',
	},
	ticketPrice: {
		width: '140px',
	},

	purchaser: {
		display: 'grid',
		gridTemplateColumns: 'repeat(5, 1fr) 36px',
		gap: '12px',
		alignItems: 'end',
	},

	meals: {
		maxWidth: '253px',
		width: '100%',
	},

	title: {
		textTransform: 'capitalize',
	},

	popup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '20px',
		height: '100%',
	},

	drawer: {
		position: 'fixed',
		bottom: '0',
		left: '0',
		right: '0',

		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},
	text: {},

	coverFeeTooltip: {
		display: 'flex',

		'& svg': {
			width: '18px',
			height: '18px',
			'& path': {fill: 'var(--neutral-300)'},
		},
	},

	textWithTooltip: {
		display: 'flex',
		gap: '4px',
		alignItems: 'center',
		marginBottom: '20px',
	},

	menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },
};
